import type React from 'react';

import { Button } from 'library/components/common';
import { Product, Spinner } from 'library/components/shop';
import { useOrder } from 'library/hooks/shop';

import Information from './frames/Information/index';

import * as st from './styles.module.scss';

export const Order: React.FC = () => {
	const order = useOrder();

	return (
		<>
			{!order.order?.id && (
				<div className={st.spinner}>
					<Spinner />
				</div>
			)}
			{!!order.order?.id && (
				<>
					<div className={st.container}>
						<div className={st.products}>
							{order.order.items.map((item: any, index) => (
								<Product product={item} key={index} />
							))}
						</div>
						<Information order={order.order} />

						{(order.order.status === 'F' || order.order.status === 'A') && (
							<div className={st.buttons}>
								<Button handler={order.repeatPayment}>Оплатить заказ</Button>
							</div>
						)}
					</div>
				</>
			)}
		</>
	);
};
